import { cn } from "@/lib/utils";
import { BRAND_LOGO_ALT, BRAND_LOGO_ON_DARK_SRC, BRAND_LOGO_SRC } from "@/lib/brand";

/** Same dimensions as the public site header (landing page). */
const headerSize =
  "h-14 w-auto max-w-[9.5rem] object-contain object-left sm:h-16 sm:max-w-[10.5rem]";

const sizeClass = {
  header: headerSize,
  dashboard: headerSize,
  auth: headerSize,
  footer: headerSize,
} as const;

const toneClass = {
  default: "",
  /** White wordmark + blue plus on dark panels (dedicated PNG) */
  onDark: "drop-shadow-[0_2px_12px_rgba(0,0,0,0.4)]",
} as const;

export type AutoPlusLogoSize = keyof typeof sizeClass;
export type AutoPlusLogoTone = keyof typeof toneClass;

type Props = {
  size?: AutoPlusLogoSize;
  tone?: AutoPlusLogoTone;
  className?: string;
};

export function AutoPlusLogo({ size = "header", tone = "default", className }: Props) {
  return (
    <img
      src={tone === "onDark" ? BRAND_LOGO_ON_DARK_SRC : BRAND_LOGO_SRC}
      alt={BRAND_LOGO_ALT}
      className={cn(sizeClass[size], toneClass[tone], "bg-transparent", className)}
      decoding="async"
    />
  );
}
